import { Stack, Typography } from "@mui/material";

import {
  ISOStringToLocalReadableTimestamp,
  sortRoutePointETAsByRoutePointAndMostRecentlyCreated,
  toFullReadableAddress,
} from "utils";

interface Props {
  etas: RoutePointETA[];
}

export function PublicShipmentLatestETA(props: Props) {
  const { etas } = props;

  if (etas.length === 0) {
    return null;
  }

  const latestETA =
    sortRoutePointETAsByRoutePointAndMostRecentlyCreated(etas)[0];

  return (
    <Stack
      direction="column"
      spacing={1}
      sx={{
        borderColor: "#cecdcd",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: 2,
        p: ".5rem",
      }}
    >
      <Typography variant="body1">
        <b>Latest ETA:</b>
        {` ${ISOStringToLocalReadableTimestamp(latestETA.eta)}`}
      </Typography>
      <Typography variant="body1">
        <b>Route Point:</b>
        {` Point #${latestETA.point.point_number} - ${toFullReadableAddress(latestETA.point.point_location)}`}
      </Typography>
      {latestETA.notes && (
        <Typography variant="body1">
          <b>Notes:</b> {latestETA.notes}
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary">
        {`ETA created by: ${latestETA.created_by.user.first_name} ${latestETA.created_by.user.last_name} on ${ISOStringToLocalReadableTimestamp(latestETA.created_at)}`}
      </Typography>
    </Stack>
  );
}
